(ns renolit-roofing-service.view.laboratory-home
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.grid-table :as layout.grid-table]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.layout.user-layout :as user-layout]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.service.service :as srv.service]
            [renolit-roofing-service.shared.util.time :as shared.time]
            [renolit-roofing-service.view :as view]))

(def ^:const route-config
  {:name [:laboratory-home]
   :auth-req? true
   :parameters {}
   :controllers [{:start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(rf/reg-event-fx
 ::view.on-enter
 (fn [_ _]
   {:fx [[:dispatch [::srv.service/fetch-services-with-projects
                     {:on-success-evt [::services-loaded]}]]]}))

(rf/reg-event-fx
 ::view.on-leave
 (fn [{:keys [db]} _]
   {:db (dissoc db :laboratory-home/search)}))

(rf/reg-event-db
 ::set-search
 (fn [db [_ search]]
   (assoc db :laboratory-home/search search)))

(rf/reg-sub
 ::search
 (fn [db _]
   (get db :laboratory-home/search "")))

(rf/reg-event-db
 ::services-loaded
 (fn [db _]
   db))

(rf/reg-event-db
 ::set-active-tab
 (fn [db [_ tab]]
   (assoc db :laboratory-active-tab tab)))

(rf/reg-sub
 ::active-tab
 (fn [db _]
   (get db :laboratory-active-tab :in-review)))

(rf/reg-sub
 ::services-with-projects
 (fn [db]
   (let [services (get db :services)
         project-cache (:installer-project-cache db {})]
     (map (fn [service]
            (let [project (get project-cache (:project-id service))]
              (assoc service :project project)))
          services))))

(def ^:private in-review-statuses
  #{"laboratory" :laboratory
    "finalization-phase" :finalization-phase})

(def ^:private history-statuses
  #{"diagnosis-closed" :diagnosis-closed})

(defn- matches-search?
  [service search]
  (if (empty? search)
    true
    (let [q (str/lower-case search)
          fields [(str (:name service))
                  (str (:reason service))
                  (str (:inspector service))
                  (str (get-in service [:project :name]))
                  (str (get-in service [:project :number]))]]
      (some #(str/includes? (str/lower-case %) q) fields))))

(rf/reg-sub
 ::in-review-services
 :<- [::services-with-projects]
 :<- [::search]
 (fn [[services search] _]
   (->> services
        (filter #(and (in-review-statuses (:status %))
                      (matches-search? % search)))
        vec)))

(rf/reg-sub
 ::history-services
 :<- [::services-with-projects]
 :<- [::search]
 (fn [[services search] _]
   (->> services
        (filter #(and (history-statuses (:status %))
                      (matches-search? % search)))
        vec)))

(defn- status-label
  [status]
  (case (keyword status)
    :laboratory (t [:page.laboratory.home.tabs/in-review])
    :finalization-phase (t [:page.laboratory.home.tabs/in-review])
    :diagnosis-closed (t [:page.laboratory.home.tabs/history])
    (name status)))

(defn- tabs
  []
  (let [active-tab (rf/subscribe [::active-tab])]
    (fn []
      [:div.installer-tabs.tab-bar.tab-bar--pill
       [:div.installer-tab.tab-bar__tab
        {:class (when (= :in-review @active-tab) "tab-bar__tab--selected")
         :on-click #(rf/dispatch [::set-active-tab :in-review])}
        (t [:page.laboratory.home.tabs/in-review])]
       [:div.installer-tab.tab-bar__tab
        {:class (when (= :history @active-tab) "tab-bar__tab--selected")
         :on-click #(rf/dispatch [::set-active-tab :history])}
        (t [:page.laboratory.home.tabs/history])]])))

(defn- services-table
  [services {:keys [row-href-fn]}]
  [:div.project-list-grid-section
   [layout.grid-table/main
    {:data services
     :grid-header-extra-class "grid-table__header--laboratory-home-"
     :grid-row-extra-class "grid-table__row--laboratory-home-"
     :row-href-fn row-href-fn
     :empty-placeholder {:msg-transl-kw :page.laboratory.home/no-services}
     :cols [{:id :service-number
             :path [:name]
             :title-transl-kw :page.laboratory.home.table-header/service-number
             :cell-settings {:type :text}}
            {:id :reason
             :path [:reason]
             :title-transl-kw :page.laboratory.home.table-header/reason
             :cell-settings {:type :text}}
            {:id :diagnosis-date
             :path [:last-diagnosis-date]
             :title-transl-kw :page.laboratory.home.table-header/diagnosis-date
             :cell-settings {:type :custom
                             :component (fn [date]
                                          [:div.grid-table__cell
                                           [:span (shared.time/format-date date {})]
                                           #_[:span (when date
                                                      (if (string? date)
                                                        (let [parsed (shared.time/parse-local-date date {:format-pattern "yyyy-MM-dd"})]
                                                          (shared.time/format-local-date parsed {}))
                                                        (shared.time/format-date date {})))]])}}
            {:id :project-number
             :path [:project :number]
             :title-transl-kw :page.laboratory.home.table-header/project-number
             :cell-settings {:type :text}}
            {:id :project-name
             :path [:project :name]
             :title-transl-kw :page.laboratory.home.table-header/project-name
             :cell-settings {:type :text}}
            {:id :technician
             :path [:inspector]
             :title-transl-kw :page.laboratory.home.table-header/technician
             :cell-settings {:type :text}}
            {:id :status
             :path [:status]
             :title-transl-kw :page.laboratory.home.table-header/status
             :cell-settings {:type :custom
                             :component (fn [status]
                                          [:div.grid-table__cell
                                           [:span (status-label status)]])}}
            {:id :nav-button
             :path [:id]
             :cell-settings {:type :custom
                             :component (fn [_]
                                          [layout.icon/icon {:class ["arrow-link"]
                                                             :key :right-arrow}])}}]}]])


(defn- toolbar
  []
  [:div.project-list-toolbar
   [layout.form/item
    {:type :search
     :placeholder-transl-kw :placeholder.search
     :state (atom {})
     :path [:search]
     :on-change {:fn #(rf/dispatch [::set-search %])}
     :css-class-prefix "project-list-toolbar__search"}]])

(defn- main*
  []
  (let [active-tab (rf/subscribe [::active-tab])
        in-review-services (rf/subscribe [::in-review-services])
        history-services (rf/subscribe [::history-services])]
    (fn []
      [:div.laboratory-home
       [tabs]
       [toolbar]
       [:div.laboratory-home__content
        (let [sample-analysis-href #(nav/href (if (= (:status %) "laboratory")
                                                [:laboratory-sample-analysis]
                                                [:laboratory-report]) {:id (:id %)})
              report-href #(nav/href [:laboratory-report-summary] {:id (:id %)})]
          (case @active-tab
            :in-review [services-table @in-review-services {:row-href-fn sample-analysis-href}]
            :history [services-table @history-services {:row-href-fn report-href}]
            [services-table @in-review-services {:row-href-fn sample-analysis-href}]))]])))

(defn- main
  []
  [user-layout/main
   {:header-title-kw :page.laboratory.home/title}
   [main*]])

(defmethod view/view-display (:name route-config)
  [_]
  [main])
